import React from 'react';
import { StyledDialog } from './buyer-protection-dialog.style';

const BuyerProtectionDialog = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
    return (
        <StyledDialog isOpen={isOpen} onClose={onClose}>
            <h2>What is Buyer Protection?</h2>
            <p>Buyer Protection Fee</p>
            <p>This fee helps us keep your purchases safe. It covers:</p>
            <p>• Secure payment processing</p>
            <p>• Access to our customer support</p>
            <p>• Refunds in case the item doesn't arrive, is damaged, or not as described.</p>
        </StyledDialog>
    );
};

export default BuyerProtectionDialog;
